import styled from "styled-components";

export const PrizeValueMrGreenBox = styled.div`
    font-size: 3.2rem;
    font-weight: 900;
    background: linear-gradient(270deg, #F8F195 0.11%, #F8F3CA 50.11%, #F8F195 100.11%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    @media ${({theme}) => theme.mediaQuery.portrait} {
        text-align: center;
    }
`;